
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const TrainerImage = "/images/Sharatsir.jpg";

export default function Registration() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    contact_number: "",
    course_name: "Data Science"
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://api.instilit.com/api/register-course/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        navigate("/thank-you");
      } else {
        alert("Registration failed. Please try again.");
      }
    } catch (error) {
      alert("Error occurred while submitting the form.");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-200 via-white to-blue-100 py-10 px-4 sm:px-6 md:px-12 lg:px-24 font-sans">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10">
        
        {/* Form Section - First on Mobile */}
        <div className="order-1 lg:order-2 bg-white shadow-2xl rounded-3xl p-6 sm:p-8 md:p-10 border border-gray-100 flex flex-col justify-between">
          <div>
            <h1 className="text-2xl sm:text-3xl font-black text-blue-900 mb-4">
              🚀 Fast-Track Your Career in Data Science
            </h1>
            <p className="text-sm sm:text-base text-gray-700 mb-6 leading-relaxed">
              <span className="text-pink-600 font-semibold text-lg">Only ₹25,000</span> – Start your journey in one of the most in-demand fields.
              <br />
              <span className="text-red-600 font-bold text-sm">⏳ Enroll by 14th July – Limited seats!</span>
              <br />
              <span className="inline-block mt-2 px-3 py-2 bg-yellow-100 text-yellow-800 font-semibold text-sm rounded-full shadow">
                📅 Starts: 16th July | ⏰ 7:00–8:30 AM IST
              </span>
              <br />
              <span className="inline-block mt-3 px-3 py-2 bg-green-100 text-green-800 font-semibold text-sm rounded-full shadow">
                📚 Duration: 4 Months | 💼 100% Placement Support
              </span>
            </p>
            <form className="space-y-5 sm:space-y-6" onSubmit={handleSubmit}>
              <div>
                <label htmlFor="first_name" className="block text-sm font-semibold text-gray-700">First Name</label>
                <input id="first_name" value={formData.first_name} onChange={handleChange} className="mt-1 w-full border border-gray-300 rounded-xl px-4 py-2 focus:ring-2 focus:ring-blue-500" required />
              </div>
              <div>
                <label htmlFor="last_name" className="block text-sm font-semibold text-gray-700">Last Name</label>
                <input id="last_name" value={formData.last_name} onChange={handleChange} className="mt-1 w-full border border-gray-300 rounded-xl px-4 py-2 focus:ring-2 focus:ring-blue-500" required />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-gray-700">Email</label>
                <input type="email" id="email" value={formData.email} onChange={handleChange} className="mt-1 w-full border border-gray-300 rounded-xl px-4 py-2 focus:ring-2 focus:ring-blue-500" required />
              </div>
              <div>
                <label htmlFor="contact_number" className="block text-sm font-semibold text-gray-700">Contact Number</label>
                <input type="tel" id="contact_number" value={formData.contact_number} onChange={handleChange} className="mt-1 w-full border border-gray-300 rounded-xl px-4 py-2 focus:ring-2 focus:ring-blue-500" required />
              </div>
              <div>
                <label htmlFor="course_name" className="block text-sm font-semibold text-gray-700">Course Name</label>
                <input id="course_name" value={formData.course_name} disabled className="mt-1 w-full border border-gray-300 rounded-xl px-4 py-2 bg-gray-100 cursor-not-allowed" />
              </div>
              <button
                type="submit"
                className="w-full mt-3 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white text-lg py-3 rounded-xl font-semibold shadow-md transition duration-200"
              >
                🎓 Enroll Now
              </button>
            </form>
          </div>
        </div>

        {/* Left Section - Second on Mobile */}
        <div className="order-2 lg:order-1 bg-white rounded-3xl shadow-2xl p-6 sm:p-8 md:p-10 border-t-4 border-blue-500 flex flex-col justify-between">
          <div className="mb-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
              📊 Data Science Course Overview
            </h2>
            <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
              Master data-driven decision making. Learn foundational programming, machine learning & AI techniques — all in one course.
            </p>
          </div>

          {/* Trainer Info */}
          <div className="mb-8">
            <h3 className="text-lg sm:text-xl font-semibold text-blue-800 mb-3">👨‍🏫 Conducted by:</h3>
            <div className="flex flex-col sm:flex-row items-start bg-blue-50 p-4 sm:p-6 rounded-2xl shadow-md">
              <img src={TrainerImage} alt="Trainer" className="w-24 h-24 sm:w-28 sm:h-28 rounded-full border-2 border-blue-600 object-cover shadow-md mb-4 sm:mb-0 sm:mr-6" />
              <div>
                <h3 className="text-lg font-bold text-blue-900">Mr. Sharat Manikonda</h3>
                <p className="text-sm text-gray-700">Senior Data Scientist with 12+ years of experience. Renowned for practical teaching and insights.</p>
                <p className="text-sm text-gray-700 mt-1">📞 +91-9885088485</p>
                <a
                  href="https://www.linkedin.com/in/sharat-manikonda/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 underline text-sm font-medium mt-1 inline-block"
                >
                  🔗 LinkedIn Profile
                </a>
              </div>
            </div>
          </div>

          {/* Curriculum */}
          <div>
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
              📘 Curriculum Highlights
            </h2>
            <ul className="space-y-3 text-gray-800 text-sm sm:text-base">
              {[
                "Python for Data Science",
                "SQL for Data Handling",
                "Basic Statistics & Data Mining",
                "Machine Learning",
                "Deep Learning",
                "Gen AI Primer"
              ].map((topic, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-blue-600 text-lg mr-2">✔</span>
                  <span>{topic}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
